import TypeformModal from './TypeformModal';
export default TypeformModal;